import { Stack } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import CardsList from "@/components/cardsList";
import { LBGhoverEffect } from "styles/hoverPresets";
import { NETWORK_AUTOMATION_CONSTANTS } from "./constants";

const ServicesComponent = () => {
  const TextVariant = useTextVariant();
  return (
    <Stack gap={6} align={"center"}>
      <CardsList
        columns={{ base: 1, sm: 2 }}
        title={NETWORK_AUTOMATION_CONSTANTS.title}
        desc={NETWORK_AUTOMATION_CONSTANTS.desc}
        list={NETWORK_AUTOMATION_CONSTANTS.list}
        spacing={{ base: 8, md: 16 }}
        hoverEffect
        hover={LBGhoverEffect}
      />
      <Text variant={TextVariant} color="text.100">
        {NETWORK_AUTOMATION_CONSTANTS.conclusion}
      </Text>
    </Stack>
  );
};

export default ServicesComponent;
